import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import RegisterPage from "./pages/RegisterPage";
import JoinPage from "./pages/JoinPage";
import DashboardPage from "./pages/DashboardPage";
import CharacterLibraryPage from "./pages/CharacterLibraryPage";
import AssetsLibraryPage from "./pages/AssetsLibraryPage";
import GameRoomPage from "./pages/GameRoomPage";
import BookPage from "./pages/BookPage";
import RaidDashboardPage from "./pages/RaidDashboardPage";
import GameShowPage from "./pages/GameShowPage";
import GameShowScoreboardPopoutPage from "./pages/GameShowScoreboardPopoutPage";
import AccountPage from "./pages/AccountPage";
import BillingPage from "./pages/BillingPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import KnightsFeePage from "./pages/KnightsFeePage";
import KnightsFeeProfilePage from "./pages/KnightsFeeProfilePage";
import BazaarPage from "./pages/BazaarPage";
import BazaarSuccessPage from "./pages/BazaarSuccessPage";
import SellerTermsPage from "./pages/SellerTermsPage";
import BuyerTermsPage from "./pages/BuyerTermsPage";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
        <div className="animate-pulse text-sm tracking-[0.2em] uppercase text-muted-foreground">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="dark App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/join/:inviteCode" element={<JoinPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/legal/seller-terms" element={<SellerTermsPage />} />
            <Route path="/legal/buyer-terms" element={<BuyerTermsPage />} />
            <Route
              path="/billing"
              element={
                <ProtectedRoute>
                  <BillingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/characters"
              element={
                <ProtectedRoute>
                  <CharacterLibraryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/assets"
              element={
                <ProtectedRoute>
                  <AssetsLibraryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/game/:gameId"
              element={
                <ProtectedRoute>
                  <GameRoomPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/game/:gameId/book/:bookType"
              element={
                <ProtectedRoute>
                  <BookPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/raid/:raidId"
              element={
                <ProtectedRoute>
                  <RaidDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gameshow/:showId"
              element={
                <ProtectedRoute>
                  <GameShowPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gameshow/:showId/scoreboard"
              element={
                <ProtectedRoute>
                  <GameShowScoreboardPopoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/knights-fee"
              element={
                <ProtectedRoute>
                  <KnightsFeePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/knights-fee/u/:userId"
              element={
                <ProtectedRoute>
                  <KnightsFeeProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bazaar"
              element={
                <ProtectedRoute>
                  <BazaarPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bazaar/success"
              element={
                <ProtectedRoute>
                  <BazaarSuccessPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
